import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "breadcrumbs" }
const _hoisted_2 = {
  dsf_level: "s-medium",
  class: "dsf-hidden-mobile"
}
const _hoisted_3 = {
  dsf_level: "s-semibold",
  class: "dsf-hidden-tablet dsf-hidden-desktop"
}
const _hoisted_4 = {
  slot: "navigation",
  dsf_gap: "l"
}

import { computed } from 'vue'
import HelpCenter from './components/HelpCenter.vue'
import ProfileMenu from './components/ProfileMenu.vue'
import { i18n } from '@/services/i18n'
import router from '@/router'
import errorsHandler from '@/services/errors-handler'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutHeader',
  emits: ['on-mobile-menu-click'],
  setup(__props, { emit }) {

const headerText = computed(() => {
  const currentRoute = router.currentRoute.value
  if (!currentRoute.name) {
    errorsHandler(
      `[tms-shell - AppLayoutHeader]: Route name is not defined in the route:
      ${JSON.stringify(currentRoute)}`
    )
    return
  }
  const key = `navigation.item.${(currentRoute.name as string).toLowerCase()}`
  return i18n.global.t(key)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("dsf-text", _hoisted_2, _toDisplayString(headerText.value), 1 /* TEXT */),
      _createElementVNode("dsf-text", _hoisted_3, _toDisplayString(headerText.value), 1 /* TEXT */)
    ]),
    _createElementVNode("dsf-row", _hoisted_4, [
      _createCommentVNode(" Help "),
      _createVNode(HelpCenter),
      _createCommentVNode(" Desktop profile "),
      _createVNode(ProfileMenu, { class: "dsf-hidden-mobile" }),
      _createCommentVNode(" Mobile navigation "),
      _createElementVNode("dsf-icon-button", {
        class: "dsf-hidden-tablet dsf-hidden-desktop",
        id: "hamburger",
        dsf_icon: "Menu",
        dsf_size: "medium",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-mobile-menu-click')))
      })
    ])
  ]))
}
}

})